export const appConfig = {
    // apiUrl: 'http://localhost:4000'
    // apiUrl: 'https://brite-testing-2.herokuapp.com'
    // apiUrl: 'https://brite-production.herokuapp.com'
    // apiUrl: 'https://brite-3.herokuapp.com'
    // apiUrl: 'https://maple-zed-08375.herokuapp.com'
    apiUrl: 'https://mighty-refuge-82284.herokuapp.com'
};